<template>
  <div class="container sv025">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>セブン銀行スマホATMでお借り入れ</HeadingOne>

    <p>
      au PAY
      スマートローンアプリをインストールすると、原則24時間365日全国のセブン銀行ATMでカードレスでお借り入れができます。
    </p>

    <ListGroup class="-note">
      <ListItem class="-note"
        >ご利用にはau PAY スマートローンアプリが必要となります。</ListItem
      >
      <ListItem class="-note"
        >システムメンテナンスなどでご利用いただけない場合がございます。</ListItem
      >
    </ListGroup>

    <ListGroup class="-link _mb-md-60 _mb-sm-4 0">
      <ListItem class="-link" router-name="sv059"
        >会員さま専用サイト・専用アプリの使い方について</ListItem
      >
    </ListGroup>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>セブン銀行スマホATMでのお借り入れ方法</HeadingTwo>
      <StepList type="sv" class="_mb-md-60 _mb-sm-20 -orange">
        <StepItem
          number="1"
          title="au PAY スマートローンアプリを起動"
          src="sv/sv025/step01.jpg"
        >
          <p>スマートフォンから「au PAY スマートローンアプリ」を起動します。</p>
          <!--<BtnMain class="-normal" router-name="mb001">-->
          <!--会員さま専用サイトトップへ-->
          <!--</BtnMain>-->
        </StepItem>
        <StepItem
          number="2"
          title="「セブン銀行スマホATMでお借り入れ」を選択"
          src="sv/sv025/step02.jpg"
        >
          <p>
            アプリホーム画面の「セブン銀行スマホATMでお借り入れ」を選択します。
          </p>
        </StepItem>
        <StepItem
          number="3"
          title="暗証番号認証とSMS認証後、お借り入れ金額を入力"
          src="sv/sv025/step03.jpg"
        >
          <p>
            ご希望のお借り入れ金額を入力し「確定」をタップすると、QRコード読み取り画面が表示されます。画面を表示したまま、以降はATM画面で操作を続けてください。
          </p>
          <ListGroup class="-note">
            <ListItem class="-note">SMS認証について詳細は<router-link :to="{ name: 'sv060' }" class="-link">こちら</router-link></ListItem>
          </ListGroup>
        </StepItem>
        <StepItem
          number="4"
          title="ATM操作：「引出し・預入れ クレジット取引など」を選択"
          src="sv/sv025/step04.png"
        >
          <p>セブン銀行ATM画面より「引出し・預入れ クレジット取引など」を選択</p>
        </StepItem>
        <StepItem
          number="5"
          title="ATM操作：「スマートフォン」を選択"
          src="sv/sv025/step05.png"
        >
          <p>セブン銀行ATM画面より「スマートフォン」を選択</p>
        </StepItem>
        <StepItem number="6" title="QRコード読み取り" src="sv/sv025/step06.png">
          <p>セブン銀行ATM画面に表示されるQRコードをアプリで読み取ります。</p>
          <ListGroup class="-note">
            <ListItem class="-note"
              >au PAY
              スマートローンアプリで読み取ってください。そのほかのカメラアプリで読み取ってもお手続きできません。</ListItem
            >
          </ListGroup>
        </StepItem>
        <StepItem
          number="7"
          title="ATM操作：企業番号入力"
          src="sv/sv025/step07.png"
        >
          <p>アプリに表示される企業番号をATMへ入力します。</p>
        </StepItem>
        <StepItem
          number="8"
          title="ATM操作：ワンタイム暗証番号入力"
          src="sv/sv025/step08.png"
          class="-last"
        >
          <p>アプリに表示されるワンタイム暗証番号をATMへ入力します。</p>
        </StepItem>
        <StepFooter>
          <template #heading>お手続き完了</template>
          <template #text>
            <p class="_mt-15">
              ＡＴＭから出金されます。お取引終了後はアプリを終了してください。
            </p>
          </template>
        </StepFooter>
      </StepList>
      <ListGroup class="-note">
        <ListItem class="-note"
          >ＡＴＭ手数料として、お借り入れ、ご返済の取引金額１万円以下の場合は110円（税込）、１万円を超える場合は220円（税込）をご負担いただきます。</ListItem
        >
        <ListItem class="-note"
          >お借り入れ時に発生するＡＴＭ手数料は、次回のご返済時にご精算いただきます。</ListItem
        >
      </ListGroup>
    </section>

    <template v-if="!isWebView()">
      <section class="_mb-md-120 _mb-sm-60">
        <HeadingTwo>アプリダウンロード</HeadingTwo>
        <p>
          iOS、Androidのスマートフォンでアプリをご利用いただけます（無料）。
        </p>
        <AppDownlord></AppDownlord>
      </section>
    </template>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
// import TabHeader from '@/components/tabs/TabHeader'
// import TabItem from '@/components/tabs/TabItem'
// import TabFilled from '@/components/tabs/TabFilled'
import StepList from "@/components/steps/StepList";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
// import BtnMain from '@/components/button/BtnMain'
// import BtngroupSingle from '@/components/button/BtngroupSingle'
// import TableBox from '@/components/tables/TableBox'
// import TableBody from '@/components/tables/TableBody'
// import TableRow from '@/components/tables/TableRow'
// import TableHeader from '@/components/tables/TableHeader'
// import TableData from '@/components/tables/TableData'
import CvBox from "@/components/box/CvBox";
// import CardBox from '@/components/card/CardBox'
// import CardHeader from '@/components/card/CardHeader'
// import CardBody from '@/components/card/CardBody'
import AppDownlord from "@/components/others/AppDownlord";
import ContactBox from "@/components/box/ContactBox";
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "Sv025",
  components: {
    BreadcrumbGroup,
    ContactBox,
    AppDownlord,
    // CardBody,
    // CardHeader,
    // CardBox,
    CvBox,
    // TableData,
    // TableHeader,
    // TableRow,
    // TableBody,
    // TableBox,
    // BtngroupSingle,
    // BtnMain,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    StepList,
    // TabFilled,
    // TabItem,
    // TabHeader,
    HeadingOne,
    HeadingTwo,
  },
  setup() {
    setMeta({
      title: "セブン銀行スマホATMでお借り入れ｜お借り入れ方法",
      description:
        "セブン銀行スマホATMを利用したお借り入れ方法をご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お借り入れについて",
          routerName: "sv046",
        },
        {
          text: "セブン銀行スマホATMでお借り入れ",
          active: true,
        },
      ],
    };
  },
  methods: {
    isWebView() {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.app-downlord {
  @include mq-up(md) {
    display: flex;
    align-items: center;
  }
  > .img-box {
    text-align: center;
    @include mq-up(md) {
      width: 50%;
    }
    > .phone {
      max-width: 235px;
      width: 100%;
      @include mq-up(md) {
        max-width: 472px;
      }
    }
  }
  > .right-box {
    @include mq-up(md) {
      width: 50%;
    }
    .iphone-box,
    .android-box {
      display: flex;
      align-items: center;
      border: 1px solid $secondary;
      flex-wrap: wrap;
      border-radius: 10px;
      padding: 20px 30px;
      @include mq-up(md) {
        padding: 30px 50px;
      }
      > .ttl {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        color: $orange;
        text-align: center;
        @include mq-up(md) {
          font-size: 24px;
        }
      }
      > .txt01 {
        width: 50%;
        @include mq-down(md) {
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 0;
        }
        @include mq-up(md) {
          width: 58%;
        }
      }
      > .iphone {
        width: 100%;
        @include mq-down(md) {
          width: 50%;
        }
        @include mq-up(md) {
          max-width: 166px;
        }
      }
      > .android {
        width: 100%;
        @include mq-down(md) {
          width: 50%;
        }
        @include mq-up(md) {
          max-width: 202px;
        }
      }
    }
  }
}
a {
  &.-link {
    text-decoration: underline;
  }
}
</style>
